import { State } from "../../../state";
import { ApplyActionVisibility } from "../_CostsAndOutcomes/ApplyActionVisibility";
import { ApplySetVisibility } from "../_CostsAndOutcomes/ApplySetVisibility";
import { ApplyCosts } from "../_CostsAndOutcomes/ApplyCosts";
import { applyCostsSets } from "../_CostsAndOutcomes/applyCostsSets";
import { ApplyCostScaleChange } from "../_CostsAndOutcomes/ApplyCostScaleChange";
import { ApplyOutcomes } from "../_CostsAndOutcomes/ApplyOutcomes";
import { meetsCostRequirements } from "../_CostsAndOutcomes/meetsCostRequirements";
import { meetsCostRequirementsSets } from "../_CostsAndOutcomes/meetsCostRequirementsSets";
import { applyAchievementChecks } from "../../../Achievements/checkAchievements";

export const IncreaseCapacityGeneric = (actionId: string, state: State) => {
  const newBricks = new Map(state.bricks);
  const newActions = new Map(state.actions);
  const newSets = new Map(state.sets);
  const newActionTimestamps = state.actionTimestamps;
  const newActionsTriggeredByType = state.actionsTriggeredByType;

  const action = new Map(state.actions).get(actionId)!;

  // Check if action has any set costs
  const hasSetCosts = action.cost.some((costEntry) => costEntry.type === "set");

  // Check if action meets cost requirements
  if (hasSetCosts) {
    // Use the sets-aware cost checker
    if (!meetsCostRequirementsSets(action, newBricks, newSets)) return state;
  } else {
    // Use the brick-only cost checker
    if (!meetsCostRequirements(action, newBricks)) return state;
  }

  // Apply Action Visibility
  const { newActions: updatedActions, newActionOrder } = ApplyActionVisibility(
    action,
    newActions,
    state.actionOrder,
  );

  // Apply Set Visibility (for any BuySet actions that were just unlocked)
  ApplySetVisibility(action, updatedActions, newSets);

  // Apply Costs
  // null = result of applied costs are negative.  Should be caught during meetCostRequirements
  if (hasSetCosts) {
    // Use the sets-aware cost applier
    const result = applyCostsSets(
      action,
      newBricks,
      newSets,
      newActionTimestamps,
    );
    if (result === null) return state;
    // applyCostsSets returns updated maps, but we already have references to them
  } else {
    // Use the brick-only cost applier
    if (ApplyCosts(action, newBricks, newActionTimestamps) === null)
      return state;
  }

  // Apply Outcomes
  // null = default case was triggered
  if (ApplyOutcomes(action, newBricks, newActionTimestamps) === null)
    return state;

  // Apply Increase in costScale
  ApplyCostScaleChange(action, updatedActions);

  // Apply Acheivement Data
  const newActionsAmt = newActionsTriggeredByType.get(actionId) ?? 0;
  newActionsTriggeredByType.set(actionId, newActionsAmt + 1);

  const newState = {
    ...state,
    actionTimestamps: newActionTimestamps,
    bricks: newBricks,
    actions: updatedActions,
    actionOrder: newActionOrder,
    sets: newSets,
    totalActionsTriggered: state.totalActionsTriggered + 1,
    actionsTriggeredByType: newActionsTriggeredByType,
  };

  return applyAchievementChecks(newState);
};
